export const getAssignee = message => message?.conversation?.assignee_id;
export const isMessageFromCurrentUser = (message, currentUserId) =>
  message?.sender?.id === currentUserId;
